import { defineMessages } from 'react-intl'

export const companySwitcherMessages = defineMessages({
  label: {
    id: 'containers.settings.company_switcher.label',
    defaultMessage: 'Vaihda yritystä',
  },
  success_title: {
    id: 'containers.settings.company_switcher.success.title',
    defaultMessage: 'Yritys vaihdettu',
  },
  success_message: {
    id: 'containers.settings.company_switcher.success.message',
    defaultMessage: 'Olet nyt kirjautuneena valittuun yritykseen',
  },
  error_title: {
    id: 'containers.settings.company_switcher.error.title',
    defaultMessage: 'Yrityksen vaihto epäonnistui',
  },
  error_message: {
    id: 'containers.settings.company_switcher.error.message',
    defaultMessage: 'Yritystä ei voitu vaihtaa. Yritä uudelleen.',
  },
  switching_message: {
    id: 'containers.settings.company_switcher.switching.message',
    defaultMessage: 'Vaihdetaan yritykseen {companyName}',
  },
})
